import { render } from "./Plus.vue?vue&type=template&id=95dab5dc&scoped=true"
import script from "./Plus.vue?vue&type=script&lang=js"
export * from "./Plus.vue?vue&type=script&lang=js"

import "./Plus.vue?vue&type=style&index=0&id=95dab5dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95dab5dc"]])

export default __exports__